/*
 * @Author: snail
 * @Date: 2020-02-27 16:58:09
 * @Last Modified by: snail
 * @Last Modified time: 2020-03-26 15:36:53
 */
import { getUrlParam, getCustomerIdNew } from '../common-helper';

function randomString(len = 32) {
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678oOLloOLlVvUuI1';
  const maxPos = $chars.length;
  let actualLength = len - 13;
  actualLength = actualLength > 0 ? actualLength : 5;
  let pwd = '';
  for (let i = 0; i < actualLength; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd + new Date().getTime();
}

// 获取埋点工具的session id
const getStatisticsSessionId = () => {
  let statisticsSessionId = sessionStorage.getItem('statisticsSessionId');
  if (!statisticsSessionId) {
    statisticsSessionId =
      Math.random()
        .toString(36)
        .substring(2) + Date.now();
    sessionStorage.setItem('statisticsSessionId', statisticsSessionId);
  }
  return statisticsSessionId;
};
/**
 * 获取公共信息的集合
 */
// const fixedCommonInfoFields = ['sessionId', 'shopId'];
// const fixedCommonInfoFields = ['sessionId', 'shopId'];
// const dynamicCommonInfoFields = ['customerId', 'timestamp', 'recomdFiled', 'pageTitle', 'eventId'];
const fixedCommonInfoFields = ['shopId'];
const dynamicCommonInfoFields = ['customerId', 'timestamp', 'recomFiled', 'recomMark', 'pageTitle'];
const commonInfoUtils = {
  getEventId() {
    return randomString(48);
  },
  getRecomMark() {
    return '';
  },
  /**
   * 是否是推荐栏目
   */
  getRecomFiled() {
    return location.href.indexOf('#hot-dish') !== -1 ? '1' : '0';
  },
  /**
   * 获取用户id
   */
  getCustomerId() {
    return getCustomerIdNew();
  },
  /**
   * 获取时间戳
   */
  getTimestamp() {
    return new Date().getTime();
  },
  /**
   * 获取sessionId
   */
  getSessionId() {
    return getStatisticsSessionId();
  },
  /**
   * 获取页面名称
   */
  getPageTitle() {
    return document.title.toString();
  },
  /**
   * 门店ID
   */
  getShopId() {
    return getUrlParam('shopId');
  },
};

function getInfoByFieldsSync(fields) {
  const res = {};
  fields.forEach(field => {
    const fieldFunName = field.charAt(0).toUpperCase() + field.slice(1);
    const funName = `get${fieldFunName}`;
    let val = '';
    if (commonInfoUtils.hasOwnProperty(funName) && typeof commonInfoUtils[funName] === 'function') {
      val = commonInfoUtils[funName]();
    }
    res[field] = val;
  });
}

async function getInfoByFieldsAsync(fields) {
  const res = {};
  for (let i = 0, l = fields.length; i < l; i++) {
    const field = fields[i];
    const fieldFunName = field.charAt(0).toUpperCase() + field.slice(1);
    const funName = `get${fieldFunName}`;
    let val = '';
    if (commonInfoUtils.hasOwnProperty(funName) && typeof commonInfoUtils[funName] === 'function') {
      val = await commonInfoUtils[funName]();
    }
    res[field] = val;
  }
  return res;
}

export function getFixedInfo() {
  return getInfoByFieldsSync(fixedCommonInfoFields);
}

export function getDynamicInfo() {
  return getInfoByFieldsAsync(dynamicCommonInfoFields);
}

const pathMapPageType = {
  '/takeaway/selectDish': '外卖点餐页',
  '/orderall/dishMenu4Quik': '快餐点餐页',
  '/orderall/dishMenu4Dinner': '堂食点餐页',
};

/**
 * 根据界面路径，获取埋点的pageType字段
 */
export function getPageTypeFromUrl() {
  return pathMapPageType[location.pathname] || document.title || '';
}



// WEBPACK FOOTER //
// ./src/helper/divolte/divolteCommonInfo.js